import type { DisciplineScheduleAvailability } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleAvailabilityApiOptions {
  disciplineId: string | number
}

/** `GET /admin-api/disciplines/{discipline}/schedule/tutor-availability` — the current tutor's hours for the next
 *  8 weeks, in the customer's timezone. */
export const useDisciplineScheduleAvailabilityApi = async (
  options: DisciplineScheduleAvailabilityApiOptions,
): Promise<DisciplineScheduleAvailability | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.tutor-availability', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    return data.data ?? null
  } catch (err: unknown) {
    toast.error({ title: 'Error!', description: getAxiosErrorMessage(err) })
    return null
  }
}
